import { createStore } from 'stimulus-store';

/**
 * Store for all parts fetched from the server.
 * 
 * Store States:
 * - []: Empty array can mean either:
 *   - Parts have not been loaded yet (check partsLoadingStore if needed)
 *   - Parts have been loaded, but organization has no parts
 * - [...]: Parts have been loaded and exist
 * 
 * Each part object contains:
 * - id: Unique identifier for the part
 * - name: Display name of the part
 * - cost: Formatted cost string (e.g., "$15.99")
 */
export const allPartsStore = createStore({
    name: 'allPartsStore',
    type: Array,
    initialValue: []
});